import React from 'react';
import { makeStyles, createTheme as createMuiTheme } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker as MuiDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { ThemeProvider } from '@material-ui/styles';
import { injectIntl } from 'react-intl';
import DayButton from './DayButton';
import CollectionsItem from './CollectionsItem';
import { Typography, Dialog } from '../../components';
import { TriangleIcon } from '../../../assets/icons';

const useStyles = makeStyles(() => ({
  parent: {
    width: '350px',
    minHeight: '350px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: process.env.REACT_APP_COLOR_SECONDARY,
    border: `1px solid ${process.env.REACT_APP_COLOR_BACKGROUND_FILL}`,
  },
  label: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '25px',
  },
  circle: {
    width: '8px',
    height: '8px',
    borderRadius: 100,
    marginRight: '15px',
    marginLeft: '1px',
    marginTop: '5px'
  },
  box: {
    width: '8px',
    height: '8px',
    borderRadius: '2px',
    marginRight: '15px',
    marginLeft: '1px',
    marginTop: '5px'
  },
  triangle: {
    marginRight: '15px',
    marginLeft: '1px',
    transform: 'rotateX(180deg)',
    marginTop: '5px'
  },
  dialogCollection: {
    display: 'flex',
    flexDirection: 'row',
  }
}));

const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersCalendarHeader: {
      switchHeader: {
        display: 'none',
      },
    },
    MuiPickersBasePicker: {
      pickerView: {
        minHeight: '320px',
        justifyContent: 'initial',
        margin: 'auto',
        marginTop: '20px'
      },
    }
  },
});

const DatePicker = ({
  intl,
  value,
  className,
  month
}) => {
  const classes = useStyles();
  const thisMonth = month && month?.events?.length ? month.events : [];

  return (
    <div className={`${classes.parent} ${className}`}>
      <Typography
        className={classes.label}
        variant="bodySemiBold"
      >
        {`${moment(value).format('MMMM')} ${moment(value).format('YYYY')}`}
      </Typography>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <ThemeProvider theme={materialTheme}>
          <MuiDatePicker
            variant="static"
            margin="normal"
            disableToolbar="true"
            value={value}
            onChange={() => { }}
            onClose={() => { }}
            renderDay={(_, __, ___, dayComponent) => {
              if (!dayComponent.props.hidden) {
                const CollItemData = thisMonth.filter((item) => moment(item.date).format('YYYY-MM-DD') === moment(_).format('YYYY-MM-DD'));

                let dayData = [];
                if (CollItemData.length) {
                  dayData = CollItemData[0].collections;
                }

                if (dayData.length) {
                  return (
                    <Dialog
                      disableBackdropClick={false}
                      hasButtons={false}
                      button={(
                        <>
                          <DayButton
                            key={String(_)}
                            id={_}
                            label={moment(_).format('DD')}
                          />
                          <CollectionsItem
                            day={moment(_).format('DD')}
                            data={dayData}
                          />
                        </>
                      )}
                      title={(
                        <Typography variant="h2Medium">
                          {intl.formatMessage({ id: 'SCHEDULE.COLLECTION.MODAL.HEADER' })}
                        </Typography>
                      )}
                      content={(
                        <>
                          {
                            dayData
                            && dayData.map((item) => {
                              if (item.status !== 'is_none') {
                                if (item.shape === 'circle') {
                                  return (
                                    <div
                                      key={`collection_in_modal_${item.id}`}
                                      className={classes.dialogCollection}
                                    >
                                      <div
                                        className={classes.circle}
                                        style={{ backgroundColor: `#${item.color}` }}
                                      />
                                      <Typography className="mb-3" variant="body">
                                        {item.title}
                                      </Typography>
                                    </div>
                                  );
                                } if (item.shape === 'box') {
                                  return (
                                    <div
                                      key={`collection_in_modal_${item.id}`}
                                      className={classes.dialogCollection}
                                    >
                                      <div
                                        className={classes.box}
                                        style={{ backgroundColor: `#${item.color}` }}
                                      />
                                      <Typography className="mb-3" variant="body">
                                        {item.title}
                                      </Typography>
                                    </div>
                                  );
                                }
                                return (
                                  <div
                                    key={`collection_in_modal_${item.id}`}
                                    className={classes.dialogCollection}
                                  >
                                    <TriangleIcon
                                      color={`#${item.color}`}
                                      className={classes.triangle}
                                    />
                                    <Typography className="mb-3" variant="body">
                                      {item.title}
                                    </Typography>
                                  </div>
                                );
                              }

                              return null;
                            })

                          }

                        </>
                      )}
                    />
                  );
                }
                return (
                  <>
                    <DayButton
                      key={String(_)}
                      id={_}
                      label={moment(_).format('DD')}
                    />
                    <CollectionsItem
                      day={moment(_).format('DD')}
                      data={dayData}
                    />
                  </>
                );
              }
              return (
                <DayButton
                  isVisible={false}
                  key={String(_)}
                  id={_}
                  label=""
                  className="display-none"
                />
              );
            }}
          />
        </ThemeProvider>
      </MuiPickersUtilsProvider>
    </div>
  );
};

export default injectIntl(DatePicker);
